<template>
  <div>
    <v-container v-if="loading">
      <div class="text-xs-center">
        <v-progress-circular indeterminate :size="150" :width="8" color="green"></v-progress-circular>
      </div>
    </v-container>

    <v-container v-else grid-list-xl>
      <br>
      <v-layout wrap>
        <v-flex xs12 md3 xl2 sm6 v-for="(item, index) in wholeResponse" :key="index" mb-2>
          <v-card>
            <v-img :src="item.Poster" :aspect-ratio="1"></v-img>
            <v-card-title primary-title>
              <div>
                <h2>{{ item.Title }}</h2>
                <div>Year: {{ item.Year }}</div>
                <div>Type: {{ item.Type }}</div>
                <div>IMDB: {{ item.imdbID }}</div> 
              </div>
            </v-card-title>

            <v-card-actions class="justify-center">
              <v-btn color="green" @click="singleMovie(item.imdbID)">View</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import MovieApi from "../services/MovieApi";

export default {
  data() {
    return {
      wholeResponse: [],
      loading: true
    };
  },
  mounted() {
    MovieApi.fetchMovieCollection("harry&potter")
      .then(response => {
        this.wholeResponse = response.Search;
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    singleMovie(id) {
      this.$router.push("/movie/" + id);
    }
  }
};
</script>

<style lang="css" scoped>
.v-progress-circular {
  margin: 1rem;
}
</style>
